import _extends from 'babel-runtime/helpers/extends';

import { mapMutations, mapActions } from 'vuex';
import categoryMixin from '@/views/creative/mixin/category.js';

export default {
  mixins: [categoryMixin],

  props: {
    resourceList: {
      type: Array,
      required: true
    },

    active: {
      type: [Number, String]
    },

    resourceStyle: {
      type: Object
    },

    selectable: {
      type: Boolean,
      default: true
    },

    category: {
      type: Object,
      required: false
    }
  },

  data: function data() {
    return {
      hoverIndex: -1
    };
  },
  mounted: function mounted() {},


  methods: _extends({}, mapMutations({
    updateCurrentResource: 'creative/template/updateCurrentResource',
    updateCurrentResourceGroupTop: 'creative/template/updateCurrentResourceGroupTop'
  }), mapActions({
    changeDefaultResource: 'creative/template/changeDefaultResource'
  }), {
    handleClick: function handleClick(_ref, e) {
      var resource = _ref.resource,
          index = _ref.index;

      this.$emit('updateTop');

      if (this.selectable) {
        this.$emit('select', { resource: resource, index: index });
        this.setDefaultResource(resource);
      }
    },
    handleDblClick: function handleDblClick(_ref2) {
      var resource = _ref2.resource,
          index = _ref2.index;

      this.$emit('updateTop');
      if (this.selectable) {
        this.$emit('dblSelect', { resource: resource, index: index });
      }
    },
    setDefaultResource: function setDefaultResource(resource) {
      var newResource = _extends({}, resource, {
        is_default: 1
      });
      this.updateCurrentResource(newResource);
      this.changeDefaultResource(newResource);
    }
  })
};